import { createRemoteJWKSet, jwtVerify } from 'jose'
import env from '@/constants/env'

export const verifyJWK = async (token: string) => {
  const auth0Domain = env.PUBLIC_AUTH0_ISSUER_DOMAIN

  if (!auth0Domain) return null

  const JWKS = createRemoteJWKSet(new URL(`https://${auth0Domain}/.well-known/jwks.json`))

  return await jwtVerify(token, JWKS)
}
